import { useEffect, useState } from 'react';
import { MdSystemUpdateAlt } from 'react-icons/md';

/**
 * Non-blocking banner shown when a new app version has finished installing
 * in the background (see index.tsx's 'toola-update-available' event and
 * service-worker.js, which deliberately does not skipWaiting on its own).
 * The user decides when to reload instead of the app silently swapping
 * versions underneath an open tab.
 */
const UpdateBanner = () => {
    const [updateAvailable, setUpdateAvailable] = useState(false);

    useEffect(() => {
        const handler = () => setUpdateAvailable(true);
        window.addEventListener('toola-update-available', handler);
        return () => window.removeEventListener('toola-update-available', handler);
    }, []);

    const reload = () => {
        if (!('serviceWorker' in navigator)) {
            window.location.reload();
            return;
        }
        navigator.serviceWorker.getRegistration().then((registration) => {
            if (registration?.waiting) {
                registration.waiting.postMessage({ type: 'SKIP_WAITING' });
                // navigator.serviceWorker's 'controllerchange' listener
                // (index.tsx) reloads the page once the new SW takes over.
            } else {
                window.location.reload();
            }
        });
    };

    if (!updateAvailable) return null;

    return (
        <div className="fixed top-5 right-5 z-[9999] flex items-center gap-3 rounded-full bg-navy-700 px-5 py-2.5 text-sm font-semibold text-white shadow-xl dark:bg-navy-600">
            <MdSystemUpdateAlt className="text-xl" />
            <span>Nouvelle version disponible</span>
            <button
                onClick={reload}
                className="rounded-full bg-toola-500 px-3 py-1 transition duration-200 hover:bg-toola-600"
            >
                Recharger
            </button>
        </div>
    );
};

export default UpdateBanner;
